import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import getVariantSkuForSelectedOptionsExtended from 'components/consumer/PDP/state/helpers/getVariantSkuForSelectedOptionsExtended';
import usePdpLastHoveredOptionsExtended from '../pdpLastHoveredOptionsExtended/usePdpLastHoveredOptionsExtended';
import usePdpOptionsOrder from '../pdpOptionsOrder/usePdpOptionsOrder';

// This state is derived from other PDP state, so there is no hook to set it
const usePdpLastHoveredVariantSku = () => {
  const $ = _c(3);
  const pdpLastHoveredOptionsExtended = usePdpLastHoveredOptionsExtended();
  const pdpOptionsOrder = usePdpOptionsOrder();
  let t0;
  if ($[0] !== pdpLastHoveredOptionsExtended || $[1] !== pdpOptionsOrder) {
    t0 = getVariantSkuForSelectedOptionsExtended(pdpLastHoveredOptionsExtended, pdpOptionsOrder) || null;
    $[0] = pdpLastHoveredOptionsExtended;
    $[1] = pdpOptionsOrder;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const pdpLastHoveredVariantSku = t0;
  return pdpLastHoveredVariantSku;
};
export default usePdpLastHoveredVariantSku;